export const checkSentIconDetails = {
  checkIconType: "check_sent",
  checkNotRequestedIcon: {
    url: "/BP_resources/images/icon/check upload.svg",
    alt: "check not requested icon",
  },
  checkUploadIcon: {
    url: "/BP_resources/images/icon/check upload.svg",
    alt: "check requested icon",
  },
  checkUploadedIcon: {
    url: "/BP_resources/images/icon/CHECK SENT.svg",
    alt: "check sent icon",
  },
};
export const checkClearedIconDetails = {
  checkIconType: "check_cleared",
  checkNotRequestedIcon: {
    url: "/BP_resources/images/icon/check upload.svg",
    alt: "check not requested icon",
  },
  checkUploadIcon: {
    url: "/BP_resources/images/icon/check upload.svg",
    alt: "check requested icon",
  },
  checkUploadedIcon: {
    url: "/BP_resources/images/icon/CHECK CLEARED.svg",
    alt: "check sent icon",
  },
};
export const checkVerifyIconDetails = {
  checkIconType: "verify",
  checkNotRequestedIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "check not requested icon",
  },
  checkUploadIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "verify icon",
  },
  checkUploadedIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "verify icon",
  },
};
export const invoiceIconDetails = {
  checkIconType: "invoice",
  checkNotRequestedIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "check not requested icon",
  },
  checkUploadIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "verify icon",
  },
  checkUploadedIcon: {
    url: "/BP_resources/images/icon/documents-icon-color.svg",
    alt: "verify icon",
  },
};
